import React from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import {DialogAction, DialogBody} from '../../dashboard/styles';
import {DialogSubTitle} from '../../../../components/DialogSubTitle/styles';
import DialogContainer from '../../../../components/DialogContainer/styles';
import DialogTitle from '../../../../components/DialogTitle/styles';
import AnimateLocationDelivery from '../../../../assets/animate-delivery-red.gif';
import {OrderSuccessImage} from './styles';
import {ButtonPrimary} from '../../../../components/buttons';

/**
 * Converts UTC date from API to location local time.
 * Returns a moment in that zone for display, or null if invalid.
 */
const formattedDate = (date, timezoneId) => {
  if (!date) return null;
  const tz = timezoneId || 'America/New_York';
  const m = moment.utc(date).tz(tz);
  return m.isValid() ? m : null;
};

const getPickupEtaRangeCopy = (pickupMoment, deliveryType) => {
  if (!pickupMoment) return null;
  const start = pickupMoment.clone().subtract(5, 'minutes');
  const end = pickupMoment.clone().add(5, 'minutes');
  const range = `${start.format('h:mm A')} - ${end.format('h:mm A')}`;
  if (deliveryType === 'FutureDelivery') {
    return (
      <>
        Please have the food ready for pickup between <span>{range}</span> on{' '}
        <span>{pickupMoment.format('MM/DD/YY')}</span>.
      </>
    );
  }
  return (
    <>
      Please have the food ready for pickup between <span>{range}</span>.
    </>
  );
};

const OrderSuccess = (props) => {
  const {onClose, open, data, timezoneId} = props;
  const pickupMoment = formattedDate(data?.pickup_time, timezoneId);
  const requestedCouriers = data?.requestedCouriers || 1;
  const successfulDeliveries = data?.successfulDeliveries ?? requestedCouriers;
  const isMultiCourier = requestedCouriers > 1;
  const isPartial = isMultiCourier && successfulDeliveries < requestedCouriers;

  const title = isPartial ? (
    <>
      Your order was <span>partially created</span>
    </>
  ) : (
    <>
      Your order was created <span>successfully</span>
    </>
  );

  const multiCourierMessage = isPartial ? (
    <>
      <span>
        {successfulDeliveries} of {requestedCouriers} couriers
      </span>{' '}
      were successfully booked to pickup the order. This may be enough to carry
      it.
    </>
  ) : (
    <>
      <span>{successfulDeliveries} couriers</span> were successfully booked to
      pickup the order.
    </>
  );

  return (
    <Dialog open={open} onClose={onClose} scroll='body'>
      <DialogContainer className='DialogMd'>
        <DialogTitle>{title}</DialogTitle>
        {isMultiCourier && (
          <DialogSubTitle className='badSuccess'>
            {multiCourierMessage}
          </DialogSubTitle>
        )}
        {data?.pickup_time && pickupMoment && (
          <>
            {isMultiCourier ? (
              <DialogSubTitle className='badSuccess'>
                {getPickupEtaRangeCopy(pickupMoment, data?.deliveryType)}
              </DialogSubTitle>
            ) : (
              <>
                {data?.deliveryType === 'ASAP' && (
                  <DialogSubTitle className='badSuccess'>
                    Please have the food ready for pickup at{' '}
                    <span>{pickupMoment.format('h:mm A')}</span>
                  </DialogSubTitle>
                )}
                {data?.deliveryType === 'FutureDelivery' && (
                  <DialogSubTitle className='badSuccess'>
                    Please have the food ready for pickup at{' '}
                    <span>{pickupMoment.format('h:mm A')}</span> on{' '}
                    <span>{pickupMoment.format('MM/DD/YY')}</span>
                  </DialogSubTitle>
                )}
              </>
            )}
          </>
        )}
        <DialogBody>
          <OrderSuccessImage src={AnimateLocationDelivery} />
          <DialogAction>
            <ButtonPrimary onClick={onClose}>
              <span>Close</span>
            </ButtonPrimary>
          </DialogAction>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

OrderSuccess.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  timezoneId: PropTypes.string
};

OrderSuccess.defaultProps = {
  timezoneId: 'America/New_York'
};

export default OrderSuccess;
